/**
 * 
 * @param {Date} zacetekZavarovanja 
 * @param {Date} datumRojstva 
 */
function getZavarovalniskaStarostOsebe (
    zacetekZavarovanja,
    datumRojstva
) {
    return zacetekZavarovanja
            .getFullYear() - 
        datumRojstva
            .getFullYear();
}

function getZacetekZavarovanja(
) {
    var now = new Date();
    return new Date(
        now.getFullYear(), 
        now.getMonth()+1, 
        1
    );
}

module.exports = {
    getZacetekZavarovanja,
    getZavarovalniskaStarostOsebe,
}